import { NgModule } from '@angular/core';
import { TaskAddModule } from './task-add/task-add.module';
import { TaskListModule } from './task-list/task-list.module';
import { TaskService } from '../services/task.service';
import { TaskDetailsModule } from './task-details/task-details.module';
import { DataViewClientsService } from '../services/data-view-clients.service';

@NgModule({
  imports: [TaskListModule, TaskAddModule, TaskDetailsModule],
  exports: [TaskListModule, TaskAddModule, TaskDetailsModule],
  providers: [TaskService, DataViewClientsService],
})
export class TasksModule {}



// WEBPACK FOOTER //
// ./src/modules/tasks/pages/tasks.module.ts